/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M21 21C21 19.0487 21 15 21 15"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M3 8L8 3M3 8L8 13M3 8C7.96805 8 11.7884 8 14.6047 8C16.8418 8 17.9603 8 18.816 8.43598C19.5686 8.81947 20.1805 9.43139 20.564 10.184C21 11.0397 21 12.1598 21 14.4V14.5V15"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				d="M3 8L8 3M3 8L8 13M3 8C7.96805 8 11.7884 8 14.6047 8C16.8418 8 17.9603 8 18.816 8.43598C19.5686 8.81947 20.1805 9.43139 20.564 10.184C21 11.0397 21 12.1598 21 14.4C21 17.2167 21 20.0924 21 21"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M3 8L8 3M3 8L8 13M3 8C7.96805 8 11.7884 8 14.6047 8C16.8418 8 17.9603 8 18.816 8.43598C19.5686 8.81947 20.1805 9.43139 20.564 10.184C21 11.0397 21 12.1598 21 14.4C21 17.2167 21 20.0924 21 21"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M8 3L3 8C7.96805 8 11.7884 8 14.6047 8C16.8418 8 17.9603 8 18.816 8.43598C19.5686 8.81947 20.1805 9.43139 20.564 10.184C21 11.0397 21 12.1598 21 14.4C21 17.2167 21 20.0924 21 21M8 13L5.5 10.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M3 8L8 3M3 8L8 13M3 8C7.96805 8 11.7884 8 14.6047 8C16.8418 8 17.9603 8 18.816 8.43598C19.5686 8.81947 20.1805 9.43139 20.564 10.184C21 11.0397 21 12.1598 21 14.4C21 17.2167 21 20.0924 21 21"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				d="M3 8L8 3M3 8L8 13M3 8C7.96805 8 11.7884 8 14.6047 8C16.8418 8 17.9603 8 18.816 8.43598C19.5686 8.81947 20.1805 9.43139 20.564 10.184C21 11.0397 21 12.1598 21 14.4C21 17.2167 21 20.0924 21 21"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
]);
